import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-tt-code",
  "use": "icon-tt-code-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-tt-code\">\n<path d=\"M6.66659 13.3333L9.33325 2.66666M11.9999 5.33332L14.6666 7.99999L11.9999 10.6667M3.99992 10.6667L1.33325 7.99999L3.99992 5.33332\" stroke=\"CurrentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol